export default "__VITE_ASSET__BlnCdlO6__"